export default [
  {
    parentField: undefined,
    currentField: 'delivery_type', 
  },
  {
    parentField: undefined,
    currentField: 'delivery_info',
    isNode: true,
  },
  {
    parentField: 'delivery_info',
    currentField: 'interval', 
  },
  {
    parentField: 'delivery_info',
    currentField: 'price', 
  },
  {
    parentField: 'delivery_info',
    currentField: 'to_the_door', 
  },
  {
    parentField: 'delivery_info',
    currentField: 'to_the_door_climb', 
  },
  {
    parentField: 'delivery_info',
    currentField: 'address',
    isNode: true,
  },
  {
    parentField: 'address',
    currentField: 'street', 
  },
  {
    parentField: 'address',
    currentField: 'city', 
  },
  {
    parentField: 'address',
    currentField: 'transport_company_id', 
  },
  {
    parentField: 'address',
    currentField: 'house', 
  },
  {
    parentField: 'address',
    currentField: 'porch', 
  },
  {
    parentField: 'address',
    currentField: 'floor', 
  },
  {
    parentField: 'address',
    currentField: 'apartment', 
  },
]